import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom'
import { Auth0Provider } from "@auth0/auth0-react";
import {Provider} from "react-redux";
import {store} from "./Store/store";
import {auth0Audience, auth0ClientId, auth0Domain} from "./data/constants";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { StyledEngineProvider } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    default: {
      main: "#FFFFFF",
    },
    primary: {
      main: "#000000"
    },
    secondary: {
      main: "#34A853"
    },
    error: {
      main: "#FCAC1E"
    },
    text: {
      primary: "rgba(0, 0, 0, 0.6)",
      secondary: "rgba(0, 0, 0, 0.4)",
    },
    background: {
      default: "#f5f5f5",
      paper: "#f5f5f5",
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "rgba(0, 0, 0, 0.6)",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorDefault: {
          color: "rgba(0, 0, 0, 0.6)",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: "rgba(0, 0, 0, 0.6)",
        },
      },
    },
  },
});

const root = createRoot(document.getElementById('root'));
root.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <Auth0Provider
        domain={auth0Domain}
        clientId={auth0ClientId}
        cacheLocation={"localstorage"}
        useRefreshTokens={true}
        authorizationParams={{
          audience: auth0Audience,
          redirect_uri: window.location.origin
        }}
      >
        <Provider store={store}>
          <BrowserRouter><App/></BrowserRouter>
        </Provider>
      </Auth0Provider>
    </ThemeProvider>
  </StyledEngineProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

